import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Spin from '@hellodarwin/core/lib/components/common/spin';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { useAssistantSelector } from '../../redux/assistant-hooks';
import { selectConversationRequiresWaitNotice } from '../../redux/selectors';
import { ConversationProcessingBadge, ConversationProcessingBadgeSpinner, ConversationProcessingContainer, ConversationProcessingContent, } from './styles';
export const ConversationProcessing = ({ conversationId, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const conversationRequiresWaitNotice = useAssistantSelector((state) => conversationId
        ? selectConversationRequiresWaitNotice(state, conversationId)
        : false);
    if (!conversationRequiresWaitNotice) {
        return null;
    }
    return (_jsx(ConversationProcessingContainer, { children: _jsxs(ConversationProcessingContent, { children: [_jsxs(ConversationProcessingBadge, { children: [_jsx(ConversationProcessingBadgeSpinner, { children: _jsx(Spin, { color: theme.colors.white_1, size: "small" }) }), _jsx(Typography, { elementTheme: "overline", color: theme.colors.white_1, children: t('assistant|conversation_processing_badge') })] }), _jsx(Typography, { elementTheme: "caption", bold: true, color: theme.colors.green_status, children: t('assistant|conversation_processing_notice') })] }) }));
};
export default ConversationProcessing;
